import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { IAppointment } from 'types/appointments';
import { ITransactionType } from 'types/services';
import { RoleEnum } from 'types/user';

import { getPaymentText } from './helpers';

const PaymentText: React.FC<{ appointment?: IAppointment; transactionTypesData?: ITransactionType[] }> = ({
  appointment,
  transactionTypesData,
}) => {
  const { role: userRole } = useCurrentLoggedInUser(); // test nha
  if (!appointment) return null;
  const { clientPrice, notaryPrice } = getPaymentText(appointment, transactionTypesData);
  switch (userRole) {
    case RoleEnum.ADMIN:
      return (
        <div>
          <div className='gx-mb-2'>Client Price: ${clientPrice}</div>
          <div>Notary Cost: {notaryPrice !== undefined ? `$${notaryPrice}` : 'Not decided'}</div>
        </div>
      );

    case RoleEnum.CLIENT:
      return (
        <div>
          <span>Cost: ${clientPrice}</span>
        </div>
      );

    case RoleEnum.NOTARY:
      return (
        <div>
          <span>Payment: ${notaryPrice}</span>
        </div>
      );

    default:
      return null;
  }
};

export default PaymentText;
